import { useRef } from "react";
import {
  Box,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
} from "@mui/material";
import "./CustomTextField.scss";

interface CustomTextFieldProps {
  placeholder?: string;
  inputProps?: object;
  inputFormTitle?: string;
  type?: string;
  value: string;
  isRequired?: boolean;
  changeTrigger: (value: string) => void;
  disabled?: boolean;
  isCharacterCount?: boolean;
  maxLength?: number;
  error?: boolean;
  rows?: number;
  multi?: boolean;
  validationRegex?: RegExp;
}

const CustomTextField: React.FC<CustomTextFieldProps> = ({
  placeholder = "",
  inputProps = {},
  inputFormTitle = "",
  type = "text",
  value,
  isRequired = false,
  changeTrigger,
  disabled = false,
  isCharacterCount = false,
  maxLength = 1,
  error = false,
  rows = 0,
  multi = false,
  validationRegex
}) => {
  const textRef = useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (validationRegex && !validationRegex.test(newValue)) {
      return;
    }
    changeTrigger(newValue);
  };

  return (
    <div className="custom-textfield">
      <FormControl sx={{ flex: 1, width: "100%" }}>
        <Box className="label-area">
          <FormLabel htmlFor="textfield" className="textfield-title">
            {inputFormTitle}
            {isRequired && <span className="required-asterisk">*</span>}
          </FormLabel>
          {isCharacterCount && (
            <FormHelperText className="textfield-character-count">
              {`${value ? value.length : 0}/${maxLength}`}
            </FormHelperText>
          )}
        </Box>
        <Input
          className="textfield-input"
          type={type}
          size="small"
          required={isRequired}
          value={value}
          inputRef={textRef}
          placeholder={placeholder}
          inputProps={inputProps}
          autoComplete="off"
          onChange={handleChange}
          rows={rows}
          fullWidth
          multiline={multi}
          disabled={disabled}
          error={error}
          sx={{
            flex: 1,
            "label+&": {
              marginTop: "0px",
            },
            "&:before": {
              borderBottom: "none",
            },
            "&:after": {
              borderBottom: "none",
            },
            "&:hover:not(.Mui-disabled, .Mui-error):before": {
              borderBottom: "none",
            },
            "&.Mui-disabled:before": {
              borderBottomStyle: "none",
            },
            ".MuiInput-input": {
              padding: "0 0 1px",
              lineHeight: "24px",
            },
            "&.Mui-error": {
              border: "1px solid #D50032",
              "&.Mui-focused": {
                border: "2px solid #D50032",
              },
            },
          }}
          data-testid="modal-textbox"
        />
      </FormControl>
    </div>
  );
};

export default CustomTextField;
